/* eslint-disable react-hooks/exhaustive-deps */
import { Button, ButtonVariant, Icon, Popover, Position, Size, Tooltip } from "@blueprintjs/core"
import { useEffect, useRef, useState } from "react"
import FieldInput, { SCALAR_TYPES } from "src/libs/scalars"
import { __, getID } from "src/libs/utilities"
import { HISTORY_TYPE, IHistoryStep, ILanding } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store" 
import updateHistory from "../../utils/updateHistory"

/* Protopia Ecosystem component */
export interface IItemEditorProps {
   item: any
   items: any[]
   i: number
   type: string
}
const ItemEditor = (props: IItemEditorProps): JSX.Element => {
    const ref = useRef<HTMLDivElement>(null)
    const currentLanding : ILanding     = useLandingStore( (state: ILandingStore) => state.currentLanding )
    const [ sectionId, setSectionId ]   = useState<string>("")
    const [ dataId, setDataId ]         = useState<string>("") 

    useEffect(() => {
        const par = ref.current! as HTMLDivElement
        setSectionId( par.closest(".landing-section-container.landing-gap")?.getAttribute("id") || "" )
        setDataId( par.closest(`[data-type="${props.type}"][data-content-id]`)?.getAttribute("data-content-id") || "" )
    }, [])

    
    
    const duplicate = () => {
        const step: IHistoryStep = { 
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : "Duplicate contact"
        }
        const landing: ILanding = {
            ...currentLanding,
            sections: currentLanding.sections.map(s => {
                if(s.id === sectionId) {
                    step.prevData = JSON.parse(JSON.stringify(s))
                    step.data = {
                        ...s,
                         data: s.data.map((data: any) => {
                            console.log( data )
                            const items: any[] = data.items
                            const newItem = { 
                                ...props.item,
                                id: getID( props.type ),
                            }
                            items.splice( props.i, 0,newItem )
                            if(data.id === dataId) {
                                return { ...data, items }
                            }
                            return data
                        })
                    } 
                    return step.data
                } 
                return s
            })
        }
        updateHistory( step, landing ) 
    }

    const doDelete = () => {
        const step: IHistoryStep = { 
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : "Delete contact"
        }
        const landing: ILanding = {
            ...currentLanding,
            sections: currentLanding.sections.map(s => {
                if(s.id === sectionId) {
                    step.prevData = JSON.parse(JSON.stringify(s))
                    step.data = {
                        ...s,
                         data: s.data.map((data: any) => {
                            const items: any[] = data.items
                            items.splice( props.i, 1 ) 
                            if(data.id === dataId) {
                                return { ...data, items }
                            }
                            return data
                        })
                    }
                    return step.data
                }
                return s
            })
        }
        updateHistory( step, landing ) 
    }
    const onPrev = () => {
        const step: IHistoryStep = { 
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : "Swap contacts"
        }
        const landing: ILanding = {
            ...currentLanding,
            sections: currentLanding.sections.map(s => {
                if(s.id === sectionId) {
                    step.prevData = JSON.parse(JSON.stringify(s))
                    step.data = {
                        ...s,
                         data: s.data.map((data: any) => {
                            const items: any[] = data.items
                            const newItems = items.splice( props.i, 1 ) 
                            items.splice( props.i - 1, 0, newItems[0] ) 
                            if(data.id === dataId) {
                                return { ...data, items }
                            }
                            return data
                        })
                    }
                    return step.data
                }
                return s
            })
        }
        updateHistory( step, landing ) 
    }
    const onNext = () => {
        const step: IHistoryStep = { 
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : "Swap contacts"
        }
        const landing: ILanding = {
            ...currentLanding,
            sections: currentLanding.sections.map(s => {
                if(s.id === sectionId) {
                    step.prevData = JSON.parse(JSON.stringify(s))
                    step.data = {
                        ...s,
                         data: s.data.map((data: any) => {
                            const items: any[] = data.items
                            const newItems = items.splice( props.i, 1 ) 
                            items.splice( props.i + 1, 0, newItems[0] ) 
                            if(data.id === dataId) {
                                return { ...data, items }
                            }
                            return data
                        })
                    }
                    return step.data
                }
                return s
            })
        }
        updateHistory( step, landing ) 
    } 

    return <div className='pe-item-editor pe-surface' ref={ref}> 
        {
            props.i > 0 && <Tooltip
                position={Position.TOP_LEFT}
                content={__("Switch previous")}
            >
                <Button size={Size.SMALL} variant={ButtonVariant.SOLID}  onClick={onPrev}>
                    <Icon icon="arrow-left" size={12} />
                </Button>
            </Tooltip>
        }
        <Tooltip
            position={Position.TOP_LEFT}
            content={__("Duplicate")}
        >
            <Button size={Size.SMALL} variant={ButtonVariant.SOLID} onClick={duplicate}>
                <Icon icon="duplicate" size={12} />
            </Button>
        </Tooltip>
        {/* <Tooltip
            position={Position.TOP_LEFT}
            content={__("Add")}
        >
            <Popover
                content={ <AddItem onAdd={ onAdd } /> }
            >
                <Button size={Size.SMALL} variant={ButtonVariant.SOLID} >
                    <Icon icon="plus" size={12} />
                </Button>
            </Popover>
        </Tooltip> */}
        <Tooltip
            position={Position.TOP_LEFT}
            content={__("Delete")}
        >
            <Button size={Size.SMALL} variant={ButtonVariant.SOLID} onClick={doDelete}>
                <Icon icon="trash" size={12} />
            </Button>
        </Tooltip>
        {
            props.i < props.items.length - 1 && <Tooltip
                position={Position.TOP_LEFT}
                content={__("Switch next")}
            >
                <Button size={Size.SMALL} variant={ButtonVariant.SOLID} onClick={onNext}>
                    <Icon icon="arrow-right" size={12} />
                </Button>
            </Tooltip>
        }
    </div>
}
export default ItemEditor

export const AddItem = ({ onAdd }: any) => {
    const [value, setValue] = useState<any>("")
    return <div className="p-3">
        <FieldInput
            type={SCALAR_TYPES.MEDIA}
            editable
            value={value}
            onChange={(val: any) => setValue(val)}
        />
        <Button onClick={ () => onAdd( value ) } >
            {__("Add new item")}
        </Button>
    </div>
}